import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { AppName, CleanMessage } from "../../../../util/app";
import { ReadData } from "../../../../providers/Patient.Provider";
import AddButton from "../../../../partials/Buttons/AddButton";
import PersonalAssessmentForm from "./NewPersonalAssessment";
import PersonalAssessmentList from "./List";
import { useQuery, useMutation } from "react-apollo";
import { toast } from "react-toastify";
import { NEW_PERSONAL_ASSESSMENT, GET_PERSONAL_ASSESSMENT } from "../../../../queries/personal-assessment.query";
import LoadingSpinner from "../../../../partials/loading";
import PersonalAssessmentDetail from "./Detail";

const PersonalAssessment = ({ match }) => {
    const title = "Patient Personal Assessment";
    // local state
    const [personal, setPersonal] = useState(null);
    const [newPersonal, setNewPersonal] = useState(false);

    // patient id
    const { id } = match.params;
    // get patient object alongside the admission id
    const patient = ReadData();

    const scrollTop = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    };
    const { loading, data } = useQuery(GET_PERSONAL_ASSESSMENT, {
        onError: e => toast.error(CleanMessage(e.message)),
        variables: { patient: id }
    });

    const [createFunc, { loading: cLoading }] = useMutation(NEW_PERSONAL_ASSESSMENT, {
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d.RecordPersonalAssessment) {
                const { message } = d.RecordPersonalAssessment;
                toast.success(message);
                setNewPersonal(false);
                setPersonal(null);
                scrollTop();
            }
        },
        update: (caches, { data: { RecordPersonalAssessment } }) => {
            const { GetPatientPersonalAssessments } = caches.readQuery({
                query: GET_PERSONAL_ASSESSMENT,
                variables: { patient: id }
            });
            GetPatientPersonalAssessments.docs.unshift(RecordPersonalAssessment.doc);
            caches.writeQuery({
                query: GET_PERSONAL_ASSESSMENT,
                variables: { patient: id },
                data: { GetPatientPersonalAssessments }
            });
        }
    });
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    {/* LIST PERSONAL ASSESSMENT */}
                    {!newPersonal && !personal && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>{title}</header>
                                <div className="float-right mt-2 mr-2">
                                    <AddButton
                                        title="Add"
                                        onClick={() => {
                                            setNewPersonal(true);
                                            setPersonal(null);
                                            scrollTop();
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="card-body" style={{ minHeight: "450px" }}>
                                <LoadingSpinner loading={loading} />
                                {data && (
                                    <PersonalAssessmentList
                                        onView={item => {
                                            setPersonal(item);
                                            scrollTop();
                                            setNewPersonal(false);
                                        }}
                                        items={data.GetPatientPersonalAssessments.docs || []}
                                    />
                                )}
                            </div>
                        </div>
                    )}

                    {/* NEW PERSONAL ASSESSMENT */}
                    {newPersonal && !personal && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewPersonal(false);
                                            setPersonal(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    New {title}
                                </header>
                            </div>
                            <div className="card-body">
                                <PersonalAssessmentForm
                                    onCancel={() => {
                                        setNewPersonal(false);
                                        setPersonal(null);
                                        scrollTop();
                                    }}
                                    onSubmit={async item => {
                                        await createFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    patient: id,
                                                    admission: patient.lastAdmission
                                                }
                                            }
                                        });
                                    }}
                                />
                                <LoadingSpinner loading={cLoading} />
                            </div>
                        </div>
                    )}

                    {/* DETAIL OF PERSONAL ASSESSMENT */}
                    {!newPersonal && personal && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewPersonal(false);
                                            setPersonal(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    {title} Detail Page
                                </header>
                            </div>
                            <div className="card-body" style={{ minHeight: "450px" }}>
                                <PersonalAssessmentDetail item={personal} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default PersonalAssessment;
